import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';

import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, Subscription, Subject } from 'rxjs';
import { AolService } from '../../../services/aol';

import {
  debounceTime,
  takeUntil,
  distinctUntilChanged,
  tap,
  map,
} from 'rxjs/operators';
import {
  AssessmentModal,
  uploadAolDocumentsModal,
  ViewAssessmentModal,
  ViewDocumentModal,
  ViewNonAssessmentModal,
} from '../../../modals';
import { NonAssessmentModal } from '../../../modals/non-network-assessment/non-new-assessment-component-modal';
import { Location } from '@angular/common';
import { OptionService } from 'src/modules/features/setting/services';

@Component({
  selector: 'app-manage-aol-data-list',
  templateUrl: './manage-aol.component.html',
  styleUrls: ['./manage-aol.component.scss'],
})
export class ManageAolListComponent implements OnInit, OnDestroy {
  filter: AppFilter = new AppFilter();
  yearFilter: AppFilter = new AppFilter();

  baseUrl = environment.API_SERVER;
  pending: boolean;
  success: any;
  error: any;
  invoices: Array<any> = [];
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  departments: Array<any> = [];
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'organizationAolId',
        op: 'cn',
        data: '',
      },
    ],
  };
  customerNCCID: string;
  organizationId: string;
  advancedSearchSubscription!: Subscription;
  exportSearchSubscription!: Subscription;
  advancedSearchVisible = false;
  headers;
  exportFilter: AppFilter;
  exportSearchFilter: any;
  aolId;
  aols;
  networkAssessments;
  nonNetworkAssessments;
  organizationAol;
  totalpercentPayable: number;
  NonTotalpercentPayable: number;
  documents;
  searchOptionFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: '',
      },
      {
        field: 'optionName',
        op: 'cn',
        data: '',
      },
    ],
  };
  filterOption: AppFilter = new AppFilter({ rows: 1000 });
  lookupTemplates;
  lookupNonTemplates;
  searchNonOptionFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: '',
      },
      {
        field: 'optionName',
        op: 'cn',
        data: '',
      },
    ],
  };
  filterNonOption: AppFilter = new AppFilter({ rows: 1000 });
  private unsubscribe$: Subject<void> = new Subject<void>();
  constructor(
    private router: Router,
    private modalService: SuiModalService,
    private activatedRoute: ActivatedRoute,
    private AolService: AolService,
    private location: Location,
    private optionSvc: OptionService
  ) {
    this.searchOptionFilter.rules[0].data = 'network_operator_license_type';
    this.searchNonOptionFilter.rules[0].data =
      'non_network_operator_license_type';
    this.getLicenseType(1);
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', sord: 'desc' });
    this.yearFilter = new AppFilter({
      sidx: 'year',
      sord: 'desc',
      _search: false,
    });
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((params) => {
        this.aolId = params['id'];
        console.log('this is here');
      });
    // this.filter._search = false;
    this.exportFilter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      // sidx: "actionDate",
      rows: 1000,
      sord: 'desc',
    });
    // this.payment(1);s
  }
  goBack() {
    this.location.back();
  }

  download(invoice) {}
  getLicenseType(page) {
    this.filterOption.page = page;
    this.pending = true;
    this.optionSvc.getPublicOption({ params: this.filterOption }).subscribe(
      (res: any) => {
        this.pending = false;
        this.lookupTemplates = res.rows;
        this.getNonLicenseType(1);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
      }
    );
  }
  getNonLicenseType(page) {
    this.filterNonOption.page = page;
    this.pending = true;
    this.optionSvc.getPublicOption({ params: this.filterNonOption }).subscribe(
      (res: any) => {
        this.pending = false;
        this.lookupNonTemplates = res.rows;
        this.getPage(1);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
      }
    );
  }
  submit() {
    this.modalService
      .open(
        new ConfirmModal(
          'Submit AOL Details?',
          'Are you sure you want to submit?',
          ModalSize.Normal
        )
      )
      .onApprove(() => {
        this.save();
      })
      .onDeny(() => {});
  }
  getDocuments() {
    this.pending = true;
    this.error = null;
    this.AolService.getDocuments({
      organizationAolId: this.aols.organizationAol.organizationAolId,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.documents = res;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
      }
    );
  }
  save() {
    this.pending = true;
    this.AolService.submitAOLDetails({
      organizationAolId: this.aols.organizationAol.organizationAolId,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.success = 'Aol  Details was successfully submitted';
        this.disabled = true;
        // this.getPage(1);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
      }
    );
  }
  disabled: boolean = false;
  // get page request organization with filter params
  getPage(page: number, addToExport = false) {
    this.searchFilter.rules[0].data = this.aolId;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.filter.page = page;
    this.pending = true;
    this.error = null;
    this.AolService.getOrganizationAolDetails({
      organizationAolId: this.aolId,
      params: this.filter,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.totalItems = +res.records;
        this.rows = this.filter.rows;
        this.currentPage = this.filter.page;
        this.aols = res;
        console.log(this.aols);
        this.year = this.aols.organizationAol;
        this.organizationAol = this.aols.organizationAol;
        console.log(
          this.aols.networkAssessments.length,
          typeof this.aols.networkAssessments.length
        );
        if (this.aols.organizationAol.status === 'SUBMITTED') {
          this.disabled = true;
        }
        this.networkAssessments = this.aols.networkAssessments;
        this.networkAssessments.map((item) => {
          const name = this.lookupTemplates.filter((id) => {
            return id.optionId === item.networkOperatorLicenseType;
          });
          item.networkOperatorLicenseType = name[0]?.optionName;
        });
        this.totalpercentPayable =
          this.aols.organizationAol.networkOperatorTotal;
        this.nonNetworkAssessments = this.aols.nonNetworkAssessments;
        this.nonNetworkAssessments.map((item) => {
          const name = this.lookupNonTemplates.filter((id) => {
            return id.optionId === item.nonNetworkOperatorLicenseType;
          });
          item.nonNetworkOperatorLicenseType = name[0]?.optionName;
        });
        this.NonTotalpercentPayable =
          this.aols.organizationAol.nonNetworkOperatorTotal;
        this.getDocuments();
        this.getAllYears(1);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
      }
    );
  }
  years;
  year;
  getAllYears(page: number, addToExport = false) {
    this.yearFilter.page = page;
    this.pending = true;
    this.error = null;
    this.AolService.getOrganizationAolSummary({
      organizationId: this.organizationId,
      params: this.yearFilter,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.years = res['rows'];
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
      }
    );
  }
  selectedCurr() {
    this.disabled = false;
    this.router.navigate([
      `/contractor/aol-manage/${this.year.organizationAolId}`,
    ]);
    this.aolId = this.year.organizationAolId;
    this.totalpercentPayable = 0;
    this.NonTotalpercentPayable = 0;

    this.getPage(1);
  }
  deleteAss(data) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Network Assessment?',
          'Are you sure you want to delete?',
          ModalSize.Normal
        )
      )
      .onApprove(() => {
        this.deleteAssessment(data);
      })
      .onDeny(() => {});
  }
  deleteNonAss(data) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Non Network Assessment?',
          'Are you sure you want to delete?',
          ModalSize.Normal
        )
      )
      .onApprove(() => {
        this.deleteNonAssessment(data);
      })
      .onDeny(() => {});
  }
  deleteAssessment(data) {
    this.pending = true;
    this.AolService.deleteContractorNetworkAssessment({
      networkOperatorAssessmentId: data.networkOperatorAssessmentId,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.success = 'Aol Assessment was successfully deleted';
        this.getPage(1);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
      }
    );
  }
  deleteNonAssessment(data) {
    this.pending = true;
    this.AolService.deleteContractorNonNetworkAssessment({
      nonNetworkOperatorAssessmentId: data.nonNetworkOperatorAssessmentId,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.success = 'Aol Non Assessment was successfully deleted';
        this.getPage(1);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
      }
    );
  }
  removeObjectWithId(arr, number) {
    return arr.filter((obj) => obj.licenseNumber !== number);
  }
  viewDepartment(data) {
    this.modalService
      .open(
        new ViewAssessmentModal(
          'View Assessment',
          this.aols,
          data,
          ModalSize.Tiny
        )
      )
      .onApprove((value: any) => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }

  viewNonDepartment(data) {
    this.modalService
      .open(
        new ViewNonAssessmentModal(
          'View Assessment',
          this.aols,
          data,
          ModalSize.Tiny
        )
      )
      .onApprove((value: any) => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }
  edit(data) {
    const copy = { ...data };
    this.modalService
      .open(
        new AssessmentModal(
          'Add New Assessment',
          this.aols,
          copy,
          true,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.getPage(1);
      })
      .onDeny(() => {
        this.getPage(1);
      });
  }
  editNonAss(data) {
    const copy = { ...data };
    this.modalService
      .open(
        new NonAssessmentModal(
          'Add New Assessment',
          this.aols,
          copy,
          true,
          ModalSize.Tiny
        )
      )
      .onApprove((value: any) => {
        this.getPage(1);
      })
      .onDeny(() => {
        this.getPage(1);
      });
  }
  upload() {
    this.modalService
      .open(
        new uploadAolDocumentsModal(
          'Add New Document',
          this.aols,
          '',
          false,
          ModalSize.Tiny
        )
      )
      .onApprove((values: any) => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }
  addNonAssessment() {
    this.modalService
      .open(
        new NonAssessmentModal(
          'Add New Assessment',
          this.aols,
          {},
          false,
          ModalSize.Tiny
        )
      )
      .onApprove((value: any) => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }
  addAssessment() {
    this.modalService
      .open(
        new AssessmentModal(
          'Add New Assessment',
          this.aols,
          {},
          false,
          ModalSize.Tiny
        )
      )
      .onApprove((value: any) => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }
  viewDocument(data) {
    this.modalService
      .open(
        new ViewDocumentModal('View Document', this.aols, data, ModalSize.Tiny)
      )
      .onApprove((value: any) => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }
  deleteDocument(data) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Document?',
          'Are you sure you want to delete?',
          ModalSize.Normal
        )
      )
      .onApprove(() => {
        this.delete(data);
      })
      .onDeny(() => {});
  }
  delete(data) {
    this.pending = true;
    this.AolService.deleteDocuments({
      aolDocumentId: data,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.success = 'Aol  Document was successfully deleted';
        this.getPage(1);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
      }
    );
  }
  editDocument(data) {
    this.modalService
      .open(
        new uploadAolDocumentsModal(
          'Edit Document',
          this.aols,
          data,
          true,
          ModalSize.Tiny
        )
      )
      .onApprove((values: any) => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }
  searchRecords(search) {
    let searchFilter = this.searchFilter;
    searchFilter.rules.forEach((rule) => {
      rule.data = search;
    });
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }
  onDisplayRecords(value) {
    this.filter.rows = value;
    this.getPage(this.filter.page);
  }

  nextPage(value) {
    this.filter.page = value;
    this.getPage(this.filter.page);
  }

  advancedSearch(event: any) {
    this.exportSearchFilter = event;
    this.filter._search = true;
    this.filter.filters = JSON.stringify(event);
    this.getPage(1, true);
  }

  downloadInvoice(media: any) {
    const filename = 'invoice.xlsx';
    const url = `${this.baseUrl}/public/media/?media=${media}&file_name=${filename}`;
    window.open(url, '_blank');
  }

  exportAdv() {
    this.pending = true;
    if (this.exportSearchFilter) {
      this.exportFilter.filters = JSON.stringify(this.exportSearchFilter);
    }
    // this.invoiceAdvancedSearch
    //   .searchExport({
    //     params: { ...this.exportFilter, customerNccId: this.customerNCCID },
    //   })
    //   .subscribe(
    //     (res) => {
    //       this.downloadInvoice(res['file']);
    //       this.pending = false;
    //     },
    //     (error) => {
    //       this.pending = false;
    //       this.error = error.error ? error.error : error;
    //     }
    //   );
  }

  ngOnInit(): void {
    // this.advancedSearchSubscription =
    //   this.invoiceAdvancedSearch.toggleSearch.subscribe((route: string) => {
    //     if (route == this.invoiceAdvancedSearch.routes.list) {
    //       this.advancedSearchVisible = !this.advancedSearchVisible;
    //     }
    //   });
    // this.exportSearchSubscription =
    //   this.invoiceAdvancedSearch.exportSearch.subscribe((route: string) => {
    //     if (route == this.invoiceAdvancedSearch.routes.list) {
    //       this.exportAdv();
    //     }
    //   });
  }

  ngOnDestroy(): void {}
}
